import EventConstants from '../../constants/EventConstants'
import { AxiosUtil } from '../../utils/axios-util'
import {
  errorResponseNotification,
  successNotification,
} from '../notification-service'

export const addPivotView = pivotView => {
  const url = `${EventConstants.USER_SETTING}addPivotView`
  return AxiosUtil.post(url, pivotView, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(res => {
      successNotification('Pivot View Added Successfully')
      return res
    })
    .catch(err => {
      errorResponseNotification(err)
      throw err
    })
}

export const updatePivotView = (id, pivotView) => {
  const url = `${EventConstants.USER_SETTING}updatePivotView/${id}`
  return AxiosUtil.put(url, pivotView, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(res => {
      successNotification('Pivot View Saved Successfully')
      return res
    })
    .catch(err => {
      errorResponseNotification(err)
      throw err
    })
}

export const deletePivotView = id => {
  const url = `${EventConstants.USER_SETTING}deletePivotView/${id}`
  return AxiosUtil.delete(url, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(res => {
      successNotification('Pivot View Deleted Successfully')
      return res
    })
    .catch(err => {
      errorResponseNotification(err)
      throw err
    })
}

export const getPivotViews = (userIds, type) => {
  const url = `${EventConstants.USER_SETTING}getPivotViews?userIds=${userIds}&type=${type}`
  return AxiosUtil.get(url)
    .then(resp => {
      return resp
    })
    .catch(err => {
      errorResponseNotification(err)
      throw err
    })
}
